export default __webpack_public_path__ + "static/media/04.793586ce.jpg";